import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';

const _editLocationUserInitQuery = (userId: string) => ({
  users_location_admin_by_pk: params(
    { id: rawString(userId) },
    {
      first_name: types.string,
      last_name: types.string,
      email: types.string,
      active: types.boolean,
    }
  ),
});

export const editLocationUserInitQuery = (userId: string) =>
  gql`
    ${query(_editLocationUserInitQuery(userId))}
  `;
